import { render, staticRenderFns } from "./DemoTs.vue?vue&type=template&id=5d8eb320"
import script from "./DemoTs.vue?vue&type=script&lang=ts"
export * from "./DemoTs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports